/**
 * Resolve public media URLs (avatars, uploads) for dev and production.
 */

/**
 * @param {string|null|undefined} url
 * @param {string|number|null|undefined} [cacheBust] - e.g. profile_picture_updated_at timestamp
 * @returns {string|null}
 */
export function resolveMediaUrl(url, cacheBust) {
  if (!url) return null;

  let resolved = url;
  if (!/^https?:\/\//i.test(url)) {
    resolved = url.startsWith('/') ? url : `/${url}`;
  }

  if (cacheBust) {
    const sep = resolved.includes('?') ? '&' : '?';
    resolved = `${resolved}${sep}v=${encodeURIComponent(String(cacheBust))}`;
  }

  return resolved;
}

/**
 * Initials for avatar placeholder (e.g. "Jean Dupont" → "JD")
 */
export function getUserInitials(user) {
  if (!user) return '?';
  const first = (user.first_name || '').trim();
  const last = (user.last_name || '').trim();
  if (first || last) {
    return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
  }
  if (user.telephone) {
    return user.telephone.slice(-2);
  }
  return '?';
}
